import { FcWithChildren } from "types/fcWithChildren";

export const LmBlockHeader: FcWithChildren = ({ children }) => {
  return (
    <div className="lm__block-header">
      <h1>{children}</h1>
    </div>
  );
};
